import { IRackItem } from "@components/Pages/Locations/LocationRow/LocationMore/RackTable/Rack/RackItem/RackItem.props";
import { ILocationForList } from "@services/locations";

export enum ActionTypesLocationsE {
  SET_LOCATIONS = "SET_LOCATIONS",
  ADD_NEW_LOCATION = "ADD_NEW_LOCATION",
  DELETE_LOCATION = "DELETE_LOCATION",
  EDIT_LOCATION = "EDIT_LOCATION",
}

export interface ActionBaseLocations {
  type: ActionTypesLocationsE;
}

export interface ActionSetLocations extends ActionBaseLocations {
  payload: ILocationForList[];
}

export interface ActionAddNewLocation extends ActionBaseLocations {
  payload: ILocationForList;
}

export interface ActionDeleteLocation extends ActionBaseLocations {
  payload: string;
}

export interface ActionEditLocationType extends ActionBaseLocations {
  payload: ILocationForList;
}
